import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

import _ from "lodash";
import {usePricingsStore} from "../../stores/pricingsStore";
import {useShallow} from "zustand/react/shallow";

export const PricingListTableSearchBarHeader = ( { make, headerHeight } ) => {
    const {
        search,
        setSearch,
    } = usePricingsStore(
        useShallow((state) => ({
            search: state.search,
            setSearch: state.setSearch,
        }))
    )

    return (
        <div
            style={{ height: headerHeight }}
            className={'PricingListTableSearchBarHeader'}
        >
            <div className={'PricingListTableSearchBarHeader_make-name pricingPageTitle'}>
                {_.capitalize(make).toUpperCase()} Pricing
            </div>
            <button className="btn-add-trim">
                <AddIcon />
                Add Trim
            </button>
            <div className={'PricingListTableSearchBarHeader_search-container'}>
                <input
                    className=""
                    type="text"
                    value={search}
                    placeholder={'Keyword search a car'}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <SearchIcon/>
            </div>
        </div>
    )
}